import { render, staticRenderFns } from "./DIAS.vue?vue&type=template&id=1482d90a&scoped=true&"
import script from "./DIAS.vue?vue&type=script&lang=js&"
export * from "./DIAS.vue?vue&type=script&lang=js&"
import style0 from "./DIAS.vue?vue&type=style&index=0&id=1482d90a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482d90a",
  null
  
)

export default component.exports